export type IPositionLastPopedPopover = IDCA.IGenericFunc;

export function positionLastPopedPopover() {
  const $container = $(window.DexeroCoreApp.lastPopedPopover as any);
  const containerHTMLElm = $container[0] as HTMLElement;
  const container = containerHTMLElm.getBoundingClientRect();
  const $modal = $('body .modal.in');

  let { bottom, left } = container;

  if ($modal.length) {
    const modalDialogRect = $modal.find('.modal-dialog')[0].getBoundingClientRect();
    left -= modalDialogRect.left;
    bottom -= modalDialogRect.top;
  } else {
    const lastPopedPopoverContentHeight =
      $(window.DexeroCoreApp.lastPopedPopoverContent as any).outerHeight() || 0;
    const containerHeight = $container.outerHeight() || 0;
    const bottomOfContainer = ($container.offset() as any).top + containerHeight;
    const heightOfBody = $('body').height() || 0;
    const spaceToBottom = heightOfBody - bottomOfContainer;
    // If content is too large for bottom, we need to position it on top of element
    if (spaceToBottom < lastPopedPopoverContentHeight) {
      bottom = bottom - lastPopedPopoverContentHeight - containerHeight;
    }
  }

  if (window.DexeroCoreApp.lastPopedPopoverContentPosition === 'left') {
    $(window.DexeroCoreApp.lastPopedPopoverContent as any).css({
      left,
      top: bottom,
    });
  } else {
    $(window.DexeroCoreApp.lastPopedPopoverContent as any).css({
      left: left - ($(window.DexeroCoreApp.lastPopedPopoverContent as any).width() || 0),
      top: bottom,
    });
  }
}
